import React, { useState, useMemo } from "react";
import ProductCard from "../components/ProductCard";
import { jewelleryProducts, categories } from "../data/jewelleryData";
import "./Collections.scss";

const Collections = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [sortBy, setSortBy] = useState("featured");
  const [priceRange, setPriceRange] = useState([0, 5000]);
  const [showFilters, setShowFilters] = useState(false);

  const handleAddToCart = (product) => {
    console.log("Added to cart:", product.name);
    // Cart functionality would be implemented here
  };

  const filteredAndSortedProducts = useMemo(() => {
    let filtered = jewelleryProducts;

    // Filter by category
    if (selectedCategory !== "all") {
      filtered = filtered.filter(
        (product) => product.category === selectedCategory
      );
    }

    // Filter by price range
    filtered = filtered.filter(
      (product) =>
        product.price >= priceRange[0] && product.price <= priceRange[1]
    );

    // Sort products
    switch (sortBy) {
      case "price-low":
        filtered.sort((a, b) => a.price - b.price);
        break;
      case "price-high":
        filtered.sort((a, b) => b.price - a.price);
        break;
      case "rating":
        filtered.sort((a, b) => b.rating - a.rating);
        break;
      case "newest":
        filtered.sort((a, b) => b.isNew - a.isNew);
        break;
      default: // featured
        filtered.sort((a, b) => b.rating - a.rating);
    }

    return filtered;
  }, [selectedCategory, sortBy, priceRange]);

  const handleCategoryChange = (categoryId) => {
    setSelectedCategory(categoryId);
  };

  const handleSortChange = (sortOption) => {
    setSortBy(sortOption);
  };

  const handlePriceRangeChange = (index, value) => {
    const newRange = [...priceRange];
    newRange[index] = parseInt(value);
    setPriceRange(newRange);
  };

  return (
    <div className="collections">
      <div className="container">
        {/* Page Header */}
        <div className="page-header">
          <h1>Our Collections</h1>
          <p>Discover our exquisite range of artificial jewelry</p>
        </div>

        <div className="collections-content">
          {/* Sidebar Filters */}
          <aside
            className={`filters-sidebar ${
              showFilters ? "filters-sidebar-open" : ""
            }`}
          >
            <div className="filters-header">
              {/* <h3>Filters</h3> */}
              {/* <button
                className="close-filters"
                onClick={() => setShowFilters(false)}
              >
                ×
              </button> */}
            </div>

            {/* Category Filter */}
            <div className="filter-group">
              {/* <h4>Category</h4>
              <div className="filter-options">
                {categories.map((category) => (
                  <label key={category.id} className="filter-option">
                    <input
                      type="radio"
                      name="category"
                      value={category.id}
                      checked={selectedCategory === category.id}
                      onChange={(e) => handleCategoryChange(e.target.value)}
                    />
                    <span className="filter-label">
                      {/* {category.name} ({category.count}) */}
              {/* {category.name}
                    </span>
                  </label> */}
              {/* ))}
              </div> } */}
            </div>

            {/* Price Range Filter */}
            {/* <div className="filter-group">
              <h4>Price Range</h4>
              <div className="price-range">
                <div className="price-inputs">
                  <input
                    type="number"
                    value={priceRange[0]}
                    onChange={(e) => handlePriceRangeChange(0, e.target.value)}
                    placeholder="Min"
                    className="price-input"
                  />
                  <span>to</span>
                  <input
                    type="number"
                    value={priceRange[1]}
                    onChange={(e) => handlePriceRangeChange(1, e.target.value)}
                    placeholder="Max"
                    className="price-input"
                  />
                </div>
                <div className="price-display">
                  ₹{priceRange[0]} - ₹{priceRange[1]}
                </div>
              </div>
            </div> */}

            {/* Clear Filters */}
            {/* <button
              className="btn btn-outline clear-filters-btn"
              onClick={() => {
                setSelectedCategory("all");
                setPriceRange([0, 5000]);
              }}
            >
              Clear All Filters
            </button> */}
          </aside>

          {/* Main Content */}
          <main className="products-main">
            {/* Toolbar */}
            {/* <div className="products-toolbar"> */}
            {/* <div className="products-count">
                {filteredAndSortedProducts.length} products found
              </div> */}

            <div className="toolbar-controls">
              {/* <button
                  className="filters-toggle"
                  onClick={() => setShowFilters(!showFilters)}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <polygon points="22,3 2,3 10,12.46 10,19 14,21 14,12.46 22,3" />
                  </svg>
                  Filters
                </button> */}

              {/* <select
                  value={sortBy}
                  onChange={(e) => handleSortChange(e.target.value)}
                  className="sort-select"
                >
                  <option value="featured">Featured</option>
                  <option value="price-low">Price: Low to High</option>
                  <option value="price-high">Price: High to Low</option>
                  <option value="rating">Highest Rated</option>
                  <option value="newest">Newest First</option>
                </select> */}
              {/* </div> */}
            </div>

            {/* Products Grid */}
            <div className="products-grid">
              {filteredAndSortedProducts.length > 0 ? (
                filteredAndSortedProducts.map((product) => (
                  <ProductCard
                    key={product.id}
                    product={product}
                    onAddToCart={handleAddToCart}
                  />
                ))
              ) : (
                <div className="no-products">
                  <div className="no-products-content">
                    <h3>No products found</h3>
                    <p>Try adjusting your filters to see more products</p>
                    <button
                      className="btn"
                      onClick={() => {
                        setSelectedCategory("all");
                        setPriceRange([0, 5000]);
                      }}
                    >
                      Clear Filter
                    </button>
                  </div>
                </div>
              )}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Collections;
